import { createSlice } from '@reduxjs/toolkit';

import {
    FETCH_CONTACT,
    FETCH_CONTACT_FAILURE,
    FETCH_CONTACT_SUCCESS,
    SELECT_TAB,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    fetchContact: {
        data: {},
        errors: [],
        isFetching: false,
    },
    selectedTab: 'contact',
};

const contactFileSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [FETCH_CONTACT]: (state) => {
            state.fetchContact.isFetching = true;
        },
        [FETCH_CONTACT_FAILURE]: (state, action) => {
            state.fetchContact = {
                ...state.fetchContact,
                error: action.payload,
                isFetching: false,
            };
        },
        [FETCH_CONTACT_SUCCESS]: (state, action) => {
            state.fetchContact = {
                ...state.fetchContact,
                data: action.payload,
                isFetching: false,
            };
        },
        [SELECT_TAB]: (state, action) => {
            state.selectedTab = action.payload;
        },
    },
});

export const contactFileActions = contactFileSlice.actions;

export default contactFileSlice.reducer;
